import { render, staticRenderFns } from "./TbBatchShelvesConfig.vue?vue&type=template&id=5278012a&scoped=true"
import script from "./TbBatchShelvesConfig.vue?vue&type=script&lang=js"
export * from "./TbBatchShelvesConfig.vue?vue&type=script&lang=js"
import style0 from "./TbBatchShelvesConfig.vue?vue&type=style&index=0&id=5278012a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5278012a",
  null
  
)

export default component.exports